import type {SweetAlertOptions} from 'sweetalert2';

// SweetAlert2 carregado sob demanda: só baixa quando o primeiro alerta é exibido.
export const fireAlert = (options: SweetAlertOptions) =>
    import('sweetalert2').then(({default: Swal}) => Swal.fire(options));
